export const stateEnum = [
  { id: 'CREATED', label: 'vytvořen' },
  { id: 'SOLVED', label: 'vyřešen' },
  { id: 'FORWARDED', label: 'postoupen' },
  { id: 'CANCELED', label: 'zrušen' }
];

export const paymentMethodEnum = [
  { id: 'CASH', label: 'Hotově' },
  { id: 'CHECK', label: 'Kartou' },
  { id: 'WIRE', label: 'Přes účet' },
  { id: 'EXTERNAL', label: 'Externí' },
  { id: 'DEMANDED', label: 'Vymáhano' },
  { id: 'DEPRECATED', label: 'Odepsáno' },
  { id: 'TABLET', label: 'kartou přes tablet' }
];
export const resolutionEnum = [
  { id: 'BNP', label: 'Blok na místě nezaplacený' },
  { id: 'BNZ', label: 'Pokutový blok' },
  { id: 'NOT_HAPPENED', label: 'Skutek se nestal' },
  { id: 'FORWARDED_SO', label: 'Předáno na SO' }
];



// WEBPACK FOOTER //
// ./src/modules/delicts/_delictsEnums.ts